import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";

const baseStyle = defineStyle({});

const sizes = {
  xs: defineStyle({
    h: "104px",
    fontSize: "14px",
    p: "10px",
  }),
};

const variants = {
  tarGraystroke: defineStyle((props) => {
    const { colorScheme } = props;
    const colorCombinations = {
      white: {
        borderColor: "#dfe4ea !important",
        borderWidth: "1px",
        borderStyle: "solid",
        bg: "white",
      },
    };
    return colorCombinations[colorScheme as keyof typeof colorCombinations] || colorCombinations["white"];
  }),
};

const TextArea = defineStyleConfig({
  baseStyle,
  variants,
  sizes,
  defaultProps: {
    variant: "tarGraystroke",
    size: "xs",
  },
});
export default TextArea;
